import { Component } from "@angular/core";

// unauthorized.component.ts
@Component({
    selector: 'app-unauthorized',
    template: `<div style="display: flex; justify-content: center; align-items: center; height: 60vh; text-align: center;">
  <div style="margin-top: 40px;">
    <h2 style="color: #d9534f; font-size: 2rem; font-weight: 600;">
      🚫 No tienes permiso para acceder a esta página.
    </h2>
    <p style="color: #555; font-size: 1rem; margin-top: 10px;">
      Si crees que esto es un error, contacta con el administrador de la cuenta.
    </p>
  </div>
</div>`,
    standalone: false
})
export class UnauthorizedComponent { }